// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_DELETE_REVIEW = "Sma\u017e hodnocen\u00ed";
export const BZ2_DELETE_REVIEW_REPLY = "Sma\u017e odpov\u011b\u010f";
export const BZ2_REPLY_THE_REVIEW = "Odpov\u011bz";
